import { useQuery } from '@tanstack/react-query';

import { createApiClient } from 'lib/api/createApiClient';
import { useAuthStore } from 'lib/stores/authStore';
import config from 'utils/config';

const api = createApiClient({
    baseURL: `${config.exchangeApiUrl}/v1`,
});

export interface IntraExchangeTransferVo {
    transfer_id: string;
    user_id: string;
    amount: number;
    source: string;
    destination: string;
    status: string;
    created_ts: string;
}

interface GetIntraExchangeTransfersResponse {
    transfers: IntraExchangeTransferVo[];
    cursor: string;
}

export const intraExchangeTransfersKeys = {
    all: ['intra_exchange_transfers'] as const,
    user: (userId: string) => [...intraExchangeTransfersKeys.all, userId] as const,
};

const getIntraExchangeTransfers = async (userId: string, signal?: AbortSignal): Promise<IntraExchangeTransferVo[]> => {
    const response = await api.get<GetIntraExchangeTransfersResponse>(`/users/${userId}/intra_exchange_transfers`, {
        params: { page_size: 100 },
        signal,
    });
    return response.data.transfers ?? [];
};

export const useIntraExchangeTransfersQuery = () => {
    const userId = useAuthStore((s) => s.userId);
    const isMember = useAuthStore((s) => s.isLoggedInMember);

    return useQuery({
        queryKey: intraExchangeTransfersKeys.user(userId ?? ''),
        queryFn: ({ signal }) => getIntraExchangeTransfers(userId!, signal),
        enabled: !!userId && isMember,
    });
};
